import { TableHead } from "@mui/material"
import { RPMTableHeaderRow } from "../../../shared/table/RPMTableHeaderRow"
import { RPMTableHeaderCell } from "../../../shared/table/RPMTableHeaderCell"

export const ScheduleMeetingsHeader = () => {
    return (
        <TableHead>
            <RPMTableHeaderRow>
                <RPMTableHeaderCell width={'1px'}></RPMTableHeaderCell>
                <RPMTableHeaderCell>Category</RPMTableHeaderCell>
                <RPMTableHeaderCell>Meeting</RPMTableHeaderCell>
                <RPMTableHeaderCell>No of Events</RPMTableHeaderCell>
                <RPMTableHeaderCell>Country</RPMTableHeaderCell>
                <RPMTableHeaderCell>Pricing Status</RPMTableHeaderCell>
            </RPMTableHeaderRow>
        </TableHead>
    )
}
